"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _Typography = _interopRequireDefault(require("../../../Typography"));
var _Intl = _interopRequireDefault(require("../../../proptypes/Intl"));
var _TextAdornmentWrapper = _interopRequireDefault(require("./TextAdornmentWrapper"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var TextAdornment = function TextAdornment(_ref) {
  var intl = _ref.intl,
    message = _ref.message,
    multiline = _ref.multiline,
    disabled = _ref.disabled;
  return /*#__PURE__*/_react["default"].createElement(_TextAdornmentWrapper["default"], {
    multiline: multiline
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    kind: disabled ? 'disabled' : 'lighter',
    level: "caption"
  }, message.defaultMessage ? intl.formatMessage(message) : message));
};
TextAdornment.propTypes = process.env.NODE_ENV !== "production" ? {
  intl: _propTypes["default"].object.isRequired,
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _Intl["default"]]),
  multiline: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool
} : {};
var _default = exports["default"] = (0, _reactIntl.injectIntl)(TextAdornment);